import Stickyfill from 'stickyfilljs';
import isMobile from './responsive.js';


/*
 * Fix product gallery sticky position with Mmenu-js 
 */
let forceGallerySticky = function() {
  if(null !== productGallery){
    Stickyfill.forceSticky();
    Stickyfill.addOne(productGallery);
  }
}

/*
 * Fix photoSwipe issue with fixed header and handheld footer 
 */
let fixPhotoSwipe = function() {
  if(null !== photoSwipe){

    var config = { attributes: true, childList: false };
    const header = document.querySelector('#header');
    const handheldFooter = document.querySelector('.handheld-footer-bar');
  
    var callback = function(mutationsList) {
        for(var mutation of mutationsList) {
             if (mutation.type == 'attributes') {
                //console.log("L'attribut '" + mutation.attributeName + "' a été modifié.");
                if( photoSwipe.classList.contains('pswp--open') ){
                  header.classList.add('pswp-fix');
                  handheldFooter.classList.add('pswp-fix');
                  header.querySelector('.click-and-collect').querySelector('a').addEventListener('click', function(e){
                    e.preventDefault();
                  });
                }
                else{
                  header.classList.remove('pswp-fix');
                  handheldFooter.classList.remove('pswp-fix');
                }
            }
        }
    };
  
    var observer = new MutationObserver(callback);
    observer.observe(photoSwipe, config);
  }
}


var responsive = isMobile();
const productGallery = document.querySelector('.woocommerce div.product div.images.woocommerce-product-gallery');
var photoSwipe = document.querySelector('.pswp');

document.addEventListener('DOMContentLoaded', () => {
  forceGallerySticky();
  fixPhotoSwipe();
});

/*
* Window resize events
*/
window.addEventListener('resize', (e) => {
  responsive = isMobile();
  forceGallerySticky();
  fixPhotoSwipe();
});




(function ( $, window, document, undefined ) {

    let toggleRelated = function(element){
    let container = $(element);

    let hiddenProducts = new Array;
    container.find('.product-card').each(function(){
      if($(this).css('display') == 'none'){
        hiddenProducts.push($(this));
      }
    });

    container.find('.btn-expand').on('click', function(e){
      if(!$(this).hasClass('expand')){
        $(this).addClass('expand');
        $(this).children('span').html(__btn.__see_less_products);
        hiddenProducts.forEach(function(product){
          product.addClass('show');
        });
      }
      else {
        $(this).removeClass('expand');
        $(this).children('span').html(__btn.__see_more_products);
        hiddenProducts.forEach(function(product){
          product.removeClass('show');
        });
      }
      
    });

  }
    
  toggleRelated('.upsells');
  toggleRelated('.related');

  $('.woocommerce-review-link').on('click', function(e){
    e.preventDefault();
  });

  $('.woocommerce-product-rating').on('click', function(e){
    let anchor = $(this).children('.woocommerce-review-link').attr('href');
    let target = $(anchor);
    $("html, body").animate( { scrollTop: target.offset().top }, 1000);
  }); 

})( jQuery, window, document );
